import router from '@/router/index'
import store from '@/store/index'
import axios from 'axios'
import md5 from 'md5';

const baseUrl = process.env.VUE_APP_BASE_API
// const baseUrl = window.g_config.VUE_APP_BASE_API

const createSign = (config: any) => {
  const signStr = '4bf5ff9e466d432c842c068c4ae0a30a';
  const timestamp = new Date().getTime();
  let body = '';
  const params = config.paramsData || config.data || config.params;
  const { method, headers } = config;

  if (method.toLowerCase() === 'post') {
    const contentType = headers['Content-Type'] || headers['content-type'];
    if (!contentType) {
      body = JSON.stringify(params || '');
    } else {
      if (contentType.includes('application/x-www-form-urlencoded')) {
        body = sortJoinParams(params);
        console.log('contentType', contentType)
      } else {
        body = JSON.stringify(params || '');
      }
    }
  } else {
    body = sortJoinParams(params);
  }
  console.log('打印加密之前的数据=====', signStr + body + timestamp)
  const signature = md5(signStr + body + timestamp);
  return {
    signature,
    timestamp,
  };
};

const sortJoinParams = (params: Record<string, string | number | boolean> | null | undefined): string => {
  return params ? Object.keys(params).sort().map(key => params[key]).join('') : '';
};

const service = axios.create({
  // baseURL: baseUrl, // url = base url + request url
  timeout: 60000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
    'Content-Type': 'application/json;charset=UTF-8'
  },
  withCredentials: false // send cookies when cross-domain requests
})

// Request interceptors
service.interceptors.request.use(
  (config: any) => {
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8'
    console.log('config', config)
    // if (store.state.token) {
    //   config.headers.Authorization = store.state.token
    // }
    // if((config.data||{}).Exch){
    //   config.data.Exch = config.data.Exch.toLowerCase()
    // }
    if (config.sign) {
      config.headers = Object.assign(
        createSign(config),
        config.headers
      )

    }
    return config
  },
  (error: any) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response: any) => {
    // const res = response.data
    // if (res.code && res.code !== 0) {
    //   return Promise.reject(new Error(res.msg || 'Error'))
    // } else {
    //   return Promise.resolve(response.data)
    // }
    return Promise.resolve(response.data)
  },
  (error: any) => {
    console.log(error)
    return Promise.reject(error)
  }
)

export class Http {
  // 使用async ... await
  /**
   * axios get 请求封装
   * @param {*} url 接口地址
   * @param {*} params 接口参数？可选 { type:object }
   */
  static async get(url: string, params: any) {
    return await service.get(url, { params })
  }

  /**
   * axios post 请求封装
   * @param {*} url 接口地址
   * @param {*} params 接口参数？可选 { type:object }
   */
  static async post(url: string, params?: any, config?: any) {
    return await service.post(url, params, config)
  }
}
export default service
